import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/icons.module.scss'
import TwetchLogo from 'assets/twetch-logo.jpg'

export default function TwetchIcon(props) {
    return (
        <div className={cn(styles.twetchIcon, props.contextStyles)}>
            <img src={TwetchLogo} />
        </div>
    )
}
